module.exports = __webpack_public_path__ + "img/stijlen-romantic.7f49e94e.png";